import type { ComponentProps } from "react"
import { STREET_VIEW_ICON_PATH } from "@/v2-ui/icon/custom/streetView/streetView.constants"

export default function StreetView(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d={STREET_VIEW_ICON_PATH} fill={fill} />
    </svg>
  )
}
